<template>
    <a-card>
        <div class="table-toolbar">
            <a-button type="primary" @click="onAdd">
                <template #icon>
                    <plus-outlined/>
                </template>
                填报入口
            </a-button>
            <a-popconfirm v-if="dataSource" title="确认要删除吗?" @confirm="onDeleteBatch(deleteUrl)" >
                <a-button danger>批量删除</a-button>
            </a-popconfirm>
        </div>
        
        <a-modal width="32%" v-model:visible="visible" :maskClosable="false" :closable="false"  @ok="handleOk" @cancel="handleCancel">
            上一年度营业收入规模(万元)：
            <a-input-number style="width:100%;margin-top:20px;" v-model:value="operatingIncomeScale" :min="1"  placeholder="请输入上一年度营业收入规模(万元)" />
            <div v-if="shok&&operatingIncomeScale==null" style="color:red">*请填写数据</div>
            <!-- <FileUpload :isPdf="true" class="requStyle" v-model:value="operatingIncomeFile" :names="'需上传'+(nowYear-1)+'年完整财务报表，包括利润表、资产负债表和现金流量表(PDF文件)'"/>
            <div v-if="shokfile&&(operatingIncomeFile==null||operatingIncomeFile=='')" style="color:red">*请上传印证资料</div> -->
            <FileUpload :isPdf="true" class="requStyle" style="clear: both;" v-model:value="operatingIncomeFile1" :names="'上传'+(nowYear-1)+'年资产负债表(PDF文件)'"/>
            <div v-if="shokfile&&(operatingIncomeFile1==null||operatingIncomeFile1=='')" style="color:red">*请上传印证资料</div>
            <FileUpload :isPdf="true" class="requStyle" style="clear: both;" v-model:value="operatingIncomeFile2"  :names="'上传'+(nowYear-1)+'年利润表(PDF文件)'"/>
            <div v-if="shokfile&&(operatingIncomeFile2==null||operatingIncomeFile2=='')" style="color:red">*请上传印证资料</div>
            <FileUpload :isPdf="true" class="requStyle" style="clear: both;" v-model:value="operatingIncomeFile3"  :names="'上传'+(nowYear-1)+'年现金流量表(PDF文件)'"/>
            <div v-if="shokfile&&(operatingIncomeFile3==null||operatingIncomeFile3=='')" style="color:red">*请上传印证资料</div>
            <pre style="color:red;clear: both;"> 
*请认真核查填报的{{nowYear-1}}年度营业收入数据，若数据填报错误，积分表单未提交状态可以
选中表单删除重新填报。若数据已提交则需要平台方审核不通过方可删除数据重新填报。
种子期0万(含)-100万
初创期100万(含)-500万
成长期500万(含)-2000万
成熟期2000万(含)以上</pre>
        </a-modal>
        <a-alert type="info" showIcon class="table-alert" v-if="selectedRowKeys.length">
            <template #message>
                已选择 {{ selectedRowKeys.length }} 项
                <a @click="onClearSelected" class="ml-20 float-right">清空</a>
            </template>
        </a-alert>
        <!--普通表格-->
        <a-table
                :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
                 :columns="columns"
                 :pagination="pagination"
                 :dataSource="dataSource"
                 :loading="loading"
                 @change="onTableChange">
                 
        <template #auditStatus="{ record }">
            <a-tag v-if="record.oneAuditStatus == 1" style="color: green">通过审核</a-tag>
            <a-tag @click="errorData(record)" v-else-if="record.oneAuditStatus == 2" style="color: red;cursor: pointer;">未通过审核</a-tag>
            <a-tag v-else-if="record.oneAuditStatus == 4" style="color: red">待修改内容</a-tag>
            <a-tag v-else-if="record.oneAuditStatus == 5" style="color: red">待提交</a-tag>
            <a-tag v-else>已提交待审核</a-tag>
        </template>
        
        <template #typeEnterprise="{ record }">
            <a-tag v-if="record.typeEnterprise == 'A'">种子期</a-tag>
            <a-tag v-if="record.typeEnterprise == 'B'">初创期</a-tag>
            <a-tag v-if="record.typeEnterprise == 'C'">成长期</a-tag>
            <a-tag v-if="record.typeEnterprise == 'D'">成熟期</a-tag>
        </template>
            <template #createdTime="{ text }">{{ momentFormat(text, 'YYYY-MM-DD') }}</template>
            <template #year="record">
                <a @click="onDetail(record)">{{record.record.year}}</a>
            </template>
            <template #totalScore="record">
                <span v-if="record.record.isShow == '0'">{{record.record.totalScore}}</span>
            </template>
                <template #action="record">
                
                <a-popconfirm title="提交之后数据将不能修改，您确认要提交吗？" @confirm="changeStatus(record)">
                <a  v-if="record.record.saveStatus == 1">提交</a>
                </a-popconfirm>
                <a-divider v-if="record.record.oneAuditStatus == 5||record.record.saveStatus == 1" type="vertical" />
                <!-- <a  v-if="record.record.oneAuditStatus == 4" @click="verify(record)">补充</a> -->
                <a  v-if="record.record.oneAuditStatus == 2||record.record.oneAuditStatus == 5||record.record.oneAuditStatus == 4" @click="verify(record)">修改</a>
                <a-divider  v-if="record.record.oneAuditStatus == 2||record.record.oneAuditStatus == 4||record.record.oneAuditStatus == 5" type="vertical" />
                <a @click="showScore(record)">查看分数</a>
            </template>
        </a-table>
    </a-card>
    <Detail ref="DetailModal" :list="list" :scoreData="scoreData" :getType="getType" />
    <errorDataDetail ref="errorDataDetailModal"  :formData="getFullData" />
    <score ref="userModal" :list="list" :scoreData="scoreData" :getType="getType" />
</template>
<script>
import { companyInfo } from "@/api/companyService";
    import score from "./components/score" //分数查询
    import Detail from "./components/Detail" //分数查询
    import errorDataDetail from "./components/errorData" //错误原因
    import { enterpriseOperatingIncome } from "@/api/integral";
    import {tableListMixin} from "@/mixins";
    // import { enterpriseFillingTime } from "@/api/integralsystem";
    import {processingStatus, payment_status_render} from "@/config/variableConfig"

    const columns = [
        {title: "统计年份", dataIndex: "year", key: "year", slots: {customRender: "year"}},
        {title: "企业类型", dataIndex: "typeEnterprise", key: "typeEnterprise",
    slots: {
      customRender: "typeEnterprise",
    },},
        {title: "营业收入规模(万元)", dataIndex: "operatingIncomeScale", key: "operatingIncomeScale"},
        {title: "填写日期", dataIndex: "createdTime", key: "createdTime", slots: {customRender: "createdTime"}},
        {title: "总分", dataIndex: "totalScore", key: "totalScore", slots: {customRender: "totalScore"}},
        {title: "状态", dataIndex: "auditStatus", key: "auditStatus",
    slots: {
      customRender: "auditStatus",
    },},
        {title: "操作", dataIndex: "action", key: "action", slots: {customRender: "action"}},
    ];
    export default {
        name: "时间管理",
        mixins: [tableListMixin],
        components: {
          score,
          Detail,
          errorDataDetail
        },
        data() {
            return {
                shok: false,
                shokfile: false,
                nowYear:new Date().getFullYear(),
                noAdd:true,
                getFullData:null,
                list:null,
                scoreData: null,
                getType: null,
                currentComponent:'seed',
                getAuditStatus:null,
                getDetailNoteParam:null,
                operatingIncomeScale: null,
                operatingIncomeFile: null,
                operatingIncomeFile1: null,
                operatingIncomeFile2: null,
                operatingIncomeFile3: null,
                processingStatus,
                payment_status_render,
                queryParamFixed: {companyCode:this.$ls.get("companyCode")},
                visible:false,
                listUrl: enterpriseOperatingIncome.getPageList,
                listKeyField: "id",
                columns,
                deleteUrl: enterpriseOperatingIncome.remove,
                // editUrl:enterpriseFillingTime.saveOrUpdate
                companyInfoGet: null,
            }
        },
        methods: {
            
            getCorpInfo() {
                this.getAction({
                url: companyInfo.detail
                }).then(res => {
                                if (res.companyName && res.oraganizationCode && res.detailedAddress && res.contactsMobile && res.corporation) {
                        
                        this.getDetail()
                    }else{
                        
                        
                    this.$notification.warning({
                                message: '请完善企业信息！',
                                style: {
                                    fontWeight: '600',
                                },
                            });
                        this.$router.push({
                            path: "/sys/companyInfo"
                        })
                    }
                    
                
                })
            },
            onAdd() {
                if(this.noAdd){
                    this.getCorpInfo()
                }else{
                    this.$notification.warning({
                                message: '不在填报时间内',
                                style: {
                                    fontWeight: '600',
                                },
                            });
                }
            },
            handleOk(){
                const NoteParam = JSON.stringify(this.getDetailNoteParam);
                if(this.getAuditStatus==null||this.getAuditStatus=='5'){
                    if(this.operatingIncomeScale==null){
                        this.shok = true
                            console.log('数值',this.shok)
                    }else if(this.operatingIncomeFile1==null||this.operatingIncomeFile1==''){
                            this.shokfile = true
                        }else if(this.operatingIncomeFile2==null||this.operatingIncomeFile2==''){
                            this.shokfile = true
                        }else if(this.operatingIncomeFile3==null||this.operatingIncomeFile3==''){
                            this.shokfile = true
                        }else{
                            this.operatingIncomeFile = this.operatingIncomeFile1+','+this.operatingIncomeFile2+','+this.operatingIncomeFile3
                            this.shok = false
                            this.shokfile = false
                            this.visible = false;
                            this.$router.push({
                                    path: '/sys/integral', 
                                    query: {
                                            id: this.operatingIncomeScale,
                                            operatingIncomeFile: this.operatingIncomeFile,
                                            operatingIncomeFile1: this.operatingIncomeFile1,
                                            operatingIncomeFile2: this.operatingIncomeFile2,
                                            operatingIncomeFile3: this.operatingIncomeFile3,
                                            getDetailNoteParam:NoteParam
                                    }
                            });
                        }
                    
                        
                    
                }else{
                    this.visible = false;
                    this.$notification.warning({
                                message: '本年度已填报！',
                                style: {
                                    fontWeight: '600',
                                },
                            });
                }
            },
            getDetail() {
            this.getAction({
                    url: enterpriseOperatingIncome.detail,
                    params: { 
                        id: this.getDateId,
                    },
                    returnMsg: true,
                    }).then((res) => {
                        if(res.data.fb){
                            this.visible = false;
                            
                    this.$notification.warning({
                                message: '榜单已发布，无法再次填报',
                                style: {
                                    fontWeight: '600',
                                },
                            });
                        }else{
                            this.visible=true;
                        this.getAuditStatus = res.data.auditStatus
                        this.getDetailNoteParam = res.data
                        this.operatingIncomeScale = res.data.operatingIncomeScale
                        this.operatingIncomeFile = res.data.operatingIncomeFile
                        this.operatingIncomeFile1 = res.data.operatingIncomeFile1
                        this.operatingIncomeFile2 = res.data.operatingIncomeFile2
                        this.operatingIncomeFile3 = res.data.operatingIncomeFile3
                        // this.$router.push({path: '/sys/integral'});
                        }
                });
            },
            changeStatus(key){
                this.postAction({
                    url: enterpriseOperatingIncome.submitAutoStatus,
                    params: { 
                        id: key.record.id,
                    },
                    returnMsg: true,
                    }).then((res) => {
                        console.log(res)
                        this.loadData()
                    })
            },
            verify(key) {
                const NoteParam = JSON.stringify({type:key.record.typeEnterprise,
                      statisticsId:key.record.statisticsId});
                      
                this.$router.push({
                        path: '/sys/integral', 
                        query: {
                            id:0,
                            getDetailNoteParam:NoteParam
                        }
                    });
              },
            errorData(record){
                this.getAction({
                    url: enterpriseOperatingIncome.getManageDetail,
                    params: { 
                        statisticsId: record.statisticsId,
                        type: record.typeEnterprise
                    },
                    returnMsg: true,
                }).then((res) => {
                    this.getFullData = res.data.reasonForAudit
                    // console.log(JSON.parse(this.getFullData))
                    this.onShowModal("errorDataDetailModal",res.data);
                })
            },
            onDetail(record){
                this.getAction({
                    url: enterpriseOperatingIncome.getManageDetail,
                    params: { 
                        statisticsId: record.record.statisticsId,
                        type: record.record.typeEnterprise
                    },
                    returnMsg: true,
                }).then((res) => {
                    
                    this.onShowModal("DetailModal", res.data);
                })
            },
            showScore(key){
                this.getAction({
                    url: enterpriseOperatingIncome.detail,
                    params: { 
                        id: key.record.fillingTimeId,
                    },
                    returnMsg: true,
                }).then((res) => {
                    if(res.data.isShow==0){
                      this.scoreData = JSON.parse(res.data.scoreInformation)
                      this.getType = res.data.type
                      console.log(this.scoreData,this.getType)
                      this.list = '分值'
                      this.onShowModal("userModal");
                    }else{
                        this.$notification.warning({
                                message: '还未公布分数！请耐心等待',
                                style: {
                                fontWeight: '600',
                                },
                            });
                    }
                });
            },

            getDate() {
                this.getAction({
                    url: enterpriseOperatingIncome.getDate,
                    // params: { id: id },
                    returnMsg: true,
                }).then((res) => {
                    if(res.data.etype=='1'){
                        this.noAdd = false
                    }
                    this.getDateId = res.data.id
                    
                });
            },
            
        },
	created(){
		this.getDate()
	}

    }
</script>
<style scoped lang="less">
.requStyle{
    margin-top:20px;
    flex:1;
}
:deep(.full-modal){
    :deep(.ant-modal-content){
        height: calc(100vh);
        width:100px;
    }
}
</style>